import React from "react";
import "./ProductImageSkeleton.css";

const ProductImageSkeleton = () => {
  return (
    <div className="skeleton-image-container">
 
       

      {/* Imagen principal */}
      <div className="skeleton-image-main shimmer" />

      {/* Thumbnails */}
      <div className="skeleton-thumbs">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="skeleton-thumb shimmer" />
        ))}
      </div>

    </div>
  );
};

export default ProductImageSkeleton;
